// extracted by mini-css-extract-plugin
export default {"container":"Pin_container__NAWah","pinContainer":"Pin_pinContainer__oYB+k","inputRange":"Pin_inputRange__--1a-"};